module.exports = __webpack_public_path__ + "img/imago_cmda.96c4ddc3.png";